// extracted by mini-css-extract-plugin
module.exports = {"container":"container-2Zezf","gdsTotalPrice":"gdsTotalPrice-3n4MJ","form":"form-3rgOv","passengersToolbar__label":"passengersToolbar__label-2yWuD"};